import React, { useEffect, useState } from 'react';
import API from '../services/api';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchDashboard() {
      try {
        const res = await API.get('/superadmin/dashboard');
        setData(res.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load dashboard');
        console.error(err);
      }
    }

    fetchDashboard();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div>
      {/* ✅ NAVBAR */}
      <nav style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 20px', background: '#f0f0f0' }}>
        <div>
          <strong>Superadmin Panel</strong>
        </div>
        <div>
          <button onClick={() => navigate('/devices')} style={{ marginRight: 10 }}>
            Add Devices
          </button>
          <button onClick={() => navigate('/companies')} style={{ marginRight: 10 }}>Create Company</button>

          <button onClick={handleLogout}>Logout</button>
        </div>
      </nav>

      <div style={{ padding: 20 }}>
        <h2>Dashboard</h2>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {data ? <pre>{JSON.stringify(data, null, 2)}</pre> : <p>Loading...</p>}
      </div>


      <div style={{padding: 20}}>
        <h3>Hello</h3>
        <p> Welcome to super admin dashboard</p>

      </div>
    </div>

    

  );
}
